<table>
	<thead>
		<tr>
			<th>{{ 'campaigns.stepCascade' | translate }}</th>
			<th>{{ 'enums.SENT' | translate }}</th>
			<th>{{ 'enums.DELIVERED' | translate }}</th>
			<th>{{ 'enums.SEEN' | translate }}</th>
			<th>{{ 'enums.UNDELIVERED' | translate }}</th>
			<th>{{ 'enums.FAILED' | translate }}</th>
		</tr>
	</thead>
	<tbody>
		@for (stats of channelsStatistics; track stats; let i = $index) {
			<tr>
				<td>
					<ng-container
						*ngTemplateOutlet="
							firstColumn;
							context: {
								trafficType: stats.trafficType,
								previousChannel: channelsStatistics[i - 1]?.trafficType,
								i,
							}
						"
					>
					</ng-container>
				</td>
				@if (campaign.info.status !== CampaignStatus.SCHEDULED) {
					<td>{{ stats.sent }}</td>
					<td>{{ stats.delivered }}</td>
					<td>
						@if (stats.trafficType === TrafficType.VIBER) {
							{{ stats.seen }}
						} @else {
							<span class="tertiary">—</span>
						}
					</td>
					<td>{{ stats.undelivered }}</td>
					<td>{{ stats.failed }}</td>
				}
			</tr>
		}
	</tbody>
</table>

<ng-template #firstColumn let-i="i" let-trafficType="trafficType" let-previousChannel="previousChannel">
	<div class="step">
		<alaris-icon [name]="cu.icon(trafficType)" class="channel-icon"></alaris-icon>
		<div class="step__channel-ttl">
			<span class="channel">
				{{
					'gl.step'
						| translate
							: {
									index: i + 1,
									channel: (cu.name(trafficType) | translate),
							  }
				}}
			</span>

			@if (previousChannel) {
				@let ttl = campaignUtils.prepareTTL(campaign, previousChannel);
				@if (ttl) {
					<alaris-tag
						[alarisTooltip]="'campaigns.ttlNote2' | translate: { ttl: ttl.seconds }"
						[maxWidth]="270"
						class="ttl"
						mode="gray-light"
						size="md"
					>
						{{ 'campaigns.ttl' | translate: ttl }}
					</alaris-tag>
				}
			}
		</div>
	</div>
</ng-template>
